<template>
  <div class="container-fluid">
    <a v-if="$route.name == 'DetailCustomer'" @click="addTempFactor">
      <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4
    ></a>
    <BnpGrid v-if="$store.state.renderComponentTicket" :hasRowNum="false" :propsColumn="Column" :propsRows="Allrows" :Selectable="false" :action="true">
      <template slot="dateTimeInsert" slot-scope="props">
        {{ props.props.dateTimeInsert.slice(0, 10) }}
      </template>
      <template slot="isRasmi" slot-scope="props">
        <i class="fad" :class="props.props.isRasmi == true ? 'text-success fa-check' : 'fa-times text-danger'"></i>
      </template>
      <template slot="action-slot" slot-scope="props">
        <a v-if="$route.name == 'DetailCustomer'" @click="Detail(props.props)" class="mx-2" :data-title="'مشاهده جزئیات'"> <i class="fad fa-search"></i></a>
        <a @click="print(props.props)" class="mx-2" :data-title="'پرینت'"> <i class="fad fa-print"></i></a>
        <a @click="print2(props.props)" class="mx-2" :data-title="'پرینت با استیمول'"> <i class="fad fa-download"></i></a>
        <a v-if="$route.name == 'DetailCustomer'" @click="deleteQ(props.props)" class="mx-2" :data-title="'حذف'"> <i class="fad fa-trash"></i></a>
        <a v-if="$route.name == 'DetailCustomer'" @click="Copy(props.props)" class="mx-2" :data-title="'کپی کردن'"> <i class="fad fa-copy"></i></a>
        <a v-if="$route.name == 'DetailCustomer'" @click="Contract(props.props)" class="mx-2" :data-title="'تبدیل به قرارداد'"> <i class="fad fa-file-signature"></i></a>
      </template>
    </BnpGrid>
  </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
  data() {
    return {
      Column: [
        { name: 'Serial', label: 'سریال', visibility: true },
        { name: 'dateTimeInsert', label: 'زمان ثبت', visibility: true },
        { name: 'isRasmi', label: 'رسمی', visibility: true },
        { name: 'NameFamInserted', label: 'کاربر ایجادکننده', visibility: true },
      ],
      Allrows: [],
    }
  },
  props: ['TempFactorList', 'CustomerId'],
  methods: {},
  mounted() {
    this.Allrows = this.TempFactorList
    this.$store.state.renderComponentTicket = false
    this.$nextTick(() => {
      this.$store.state.renderComponentTicket = true
    })
  },
  methods: {
    print(data) {
      this.$router.push({ name: 'PrintTempFactor', params: { propsTempFactor: data } })
    },
    print2(data) {
      // console.log(data);
      data['LogoAddress'] = this.$cookies.get('URL') + this.$session.get('CompanyLogo')
      var DataAxios = { Method: 'POST', Action: 'ReportBuilder/TempFactorStimul', ArryfildValue: data }
      this.$PostData(DataAxios).then((result) => {
        if (result.status == 'succes') {
          var a = document.createElement('a')
          document.body.appendChild(a)
          a.style = 'display: none'
          a.setAttribute('target', '_blank');
          var url = this.$cookies.get('URL') + result.link
          // console.log(result.link.split('\\')[1])
          a.href = url
          a.download = result.link.split('\\')[1]
          // console.log(a);
          a.click()
        }
      })
    },
    Copy(data) {
      this.$router.push({ name: 'TempFactor', params: { InTempFactor: data, propsCopy: true } })
    },
    Detail(data) {
      this.$router.push({ name: 'TempFactor', params: { InTempFactor: data } })
    },
    deleteQ(data) {
      this.$SweetQustion('هشدار', 'ایا از حذف پیش فاکتور اطمینان دارید؟', 'info', 'بله', 'انصراف', data, this.Delete, this.cancel)
    },
    Delete(data) {
      var axiosDelete = { Method: 'post', Action: 'TempFactor/Delete', ArryfildValue: { Id: data.id, Usergrp: this.$session.get('UserInfo').tblUserGrpId } }
      this.$PostData(axiosDelete)
        .then((result) => {
          if (result.status == 'success') {
            this.$toasted.success('پیش فاکتور با موفقیت حذف شد', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
            this.$emit('Inserted', {
              done: 'OK',
            })
          } else {
            this.$toasted.error('خطا در حذف', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
          }
        })
        .catch((error) => {
          this.$toasted.error('خطا در حذف', {
            action: {
              text: 'بستن',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              },
            },
          })
        })
    },
    addTempFactor() {
      this.$router.push({ name: 'TempFactor', params: { propsCustomerId: this.CustomerId } })
    },
    Contract(data) {
      this.$router.push({ name: 'DetailContract', params: { Status: 'Add', tempFactoToContract: data.Id } })
    },
  },
  components: { BnpGrid },
}
</script>
